import React from "react";
import { spreadPanel as S } from "../../mock/inferraData";

export default function SpreadPanel() {
  const lines = [80, 65, 90, 70, 85, 60, 75, 50, 88, 66, 72, 58, 80, 45];
  return (
    <div
      className="card-lift"
      style={{
        background: "#fff",
        border: "1px solid rgba(20,32,27,0.16)",
        borderRadius: 12,
        overflow: "hidden",
      }}
    >
      <div style={{ height: 48, padding: "0 18px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #e6e9e6", fontSize: 13, gap: 10 }}>
        <span style={{ fontWeight: 600 }}>{S.title}</span>
        <span style={{ color: "#5a646e", fontSize: 12 }}>{S.meta}</span>
      </div>

      <div className="sp-body" style={{ display: "flex", minHeight: 400 }}>
        {/* doc page */}
        <div className="sp-doc" style={{ width: 280, flexShrink: 0, padding: 22, background: "#eef0ed", display: "flex", justifyContent: "center" }}>
          <div style={{ width: 226, background: "#fff", border: "1px solid #d8dcd8", padding: "18px 16px", display: "flex", flexDirection: "column", gap: 9 }}>
            <div style={{ fontSize: 9, fontWeight: 600 }}>Statement of profit or loss, page 14</div>
            {lines.slice(0, 2).map((w, i) => (
              <div key={`a${i}`} style={{ height: 5, width: `${w}%`, background: "#e1e4e1" }} />
            ))}
            <HiRow label="Revenue" val="57,412" />
            {lines.slice(2, 4).map((w, i) => (
              <div key={`b${i}`} style={{ height: 5, width: `${w}%`, background: "#e1e4e1" }} />
            ))}
            <HiRow label="Gross profit" val="13,905" />
            {lines.slice(4).map((w, i) => (
              <div key={`c${i}`} style={{ height: 5, width: `${w}%`, background: "#e1e4e1" }} />
            ))}
          </div>
        </div>

        {/* extraction table */}
        <div style={{ flexGrow: 1, padding: "22px 24px", display: "flex", flexDirection: "column", gap: 14, minWidth: 0 }}>
          <div style={{ display: "flex", flexDirection: "column", fontSize: 13 }}>
            <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr 0.8fr 1fr", padding: "8px 0", color: "#5a646e", fontSize: 12, borderBottom: "1px solid #e6e9e6" }}>
              <span>Template line</span>
              <span style={{ textAlign: "right" }}>USD thousands</span>
              <span style={{ textAlign: "right" }}>Source</span>
              <span style={{ textAlign: "right" }}>Confidence</span>
            </div>
            {S.rows.map((r, i) => (
              <div key={r.k} style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr 0.8fr 1fr", padding: "10px 0", borderBottom: i === S.rows.length - 1 ? "none" : "1px solid #eef0ee", alignItems: "center" }}>
                <span>{r.k}</span>
                <span style={{ textAlign: "right", fontFamily: '"IBM Plex Mono", monospace' }}>{r.v}</span>
                <span style={{ textAlign: "right", color: "var(--green)" }}>{r.src}</span>
                <span style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 6 }}>
                  {r.review && <span style={{ fontSize: 11, color: "var(--amber)" }}>Review</span>}
                  <span style={{ width: 64, height: 6, borderRadius: 3, background: "#eef0ee", overflow: "hidden" }}>
                    <span
                      style={{
                        display: "block",
                        height: "100%",
                        width: `${Math.round(r.conf * 100)}%`,
                        background: r.review ? "var(--amber-soft)" : "var(--green)",
                        borderRadius: 3,
                        transformOrigin: "left",
                        animation: `bar-grow 1s cubic-bezier(.16,1,.3,1) ${0.1 + i * 0.08}s both`,
                      }}
                    />
                  </span>
                </span>
              </div>
            ))}
          </div>
          <div style={{ flexGrow: 1 }} />
          <div className="sp-chips" style={{ display: "flex", gap: 12 }}>
            {S.chips.map((c) => (
              <div key={c.title} style={{ flex: 1, padding: "12px 14px", borderRadius: 8, background: c.tone === "ok" ? "#f4f6f4" : "#fbf5ea", fontSize: 12, lineHeight: 1.5, color: "#45514a" }}>
                <span style={{ display: "block", fontWeight: 600, color: c.tone === "ok" ? "var(--ink)" : "#7a4f0e" }}>{c.title}</span>
                {c.body}
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 760px) {
          .sp-body { flex-direction: column; }
          .sp-doc { width: 100%; }
        }
      `}</style>
    </div>
  );
}

function HiRow({ label, val }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px 6px", margin: "2px -6px", border: "1.5px solid var(--green)", borderRadius: 3, background: "#eaf2ee", fontSize: 9 }}>
      <span>{label}</span>
      <span style={{ fontFamily: '"IBM Plex Mono", monospace' }}>{val}</span>
    </div>
  );
}
